<template>
  <div class="page">
    <div style="margin-top: 5cm;" v-if="this.loading"> 
      <Loading/>
    </div>
    <main v-if="!this.loading" style="text-align: center;">
      <img src="@/assets/icon.svg" alt="waste icon" height="100">
      <br/><br/>
      <h2 style="color: black"> Driver Signup </h2>
      <br/>
      <form @submit.prevent="signUp()">
      <br/><br/>
      <div v-if="step === 1" :style="(step === 1) ? '' : 'display: none;'">
          <validation-observer ref="observer-1">
            <validation-provider
                rules="email|required"
                v-slot="{ errors }">
              <input
                autofocus="true"
                autocomplete="off"
                type="email"
                name="emailAddress"
                id="email"
                :class="(errors[0]) ? 'input-error' : ''"
                placeholder="Email"
                v-model="form.emailAddress"
              >
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider
                rules="required|phone"
                v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                autocomplete="off"
                type="text"
                name="mobile"
                id="phone"
                :class="(errors[0]) ? 'input-error' : ''"
                placeholder="eg: 0671234567"
                v-model="form.mobile"
              >
              </v-text-field>
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider
                name="password"
                rules="required|min:6"
                v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                autocomplete="off"
                name="password"
                id="password"
                placeholder="Password"
                v-model="form.password"
                :class="(errors[0]) ? 'input-error' : ''"
                :type="show ? 'text' : 'password'" 
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
              >
              </v-text-field> 
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider
                rules="required|confirmedPassword:@password"
                v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                autocomplete="off"
                name="confirm-password"
                id="confirm-password"
                placeholder="Confirm password"
                v-model="form.confirmPassword"
                :class="(errors[0]) ? 'input-error' : ''"
                :type="show ? 'text' : 'password'" 
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
              >
              </v-text-field>
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
          </validation-observer>
          <button style="background-color: #EF5350;" @click.prevent="signUp">Next <feather type="chevron-right" size=18></feather></button>
        </div>
        <div v-if="step === 2" :style="(step === 2) ? '' : 'display: none;'">
          <validation-observer ref="observer-2">
            <validation-provider
                rules="required"
                v-slot="{ errors }">
              <input
                  autocomplete="off"
                  type="text"
                  name="fname"
                  id="firstname"
                  v-model="form.fname"
                  placeholder="First name"
                  :class="(errors[0]) ? 'input-error' : ''"
              >
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <br/>
            <validation-provider
                rules="required"
                v-slot="{ errors }">
              <input
                  type="text"
                  name="lname"
                  id="lastname"
                  v-model="form.lname"
                  placeholder="Last name"
                  :class="(errors[0]) ? 'input-error' : ''"
              >
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <br/>
            <validation-provider
                v-slot="{ errors }">
              <input
                  type="text"
                  name="company_reg_no"
                  id="companyname"
                  v-model="form.companyname"
                  placeholder="Company name (if applicable)"
                  :class="(errors[0]) ? 'input-error' : ''"
              >
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
            <br/>
            <validation-provider
                v-slot="{ errors }"
                rules="vatLength">
              <input
                  type="text"
                  name="vat_no"
                  id="vat"
                  v-model="form.vat_no"
                  placeholder="VAT no. (if applicable)"
                  :class="(errors[0]) ? 'input-error' : ''"
              >
              <span class="input-error-text">{{ errors[0] }}</span>
            </validation-provider>
          </validation-observer>
          <button style="background-color: #EF5350;" @click.prevent="captureAdditionalInformation">Next <feather type="chevron-right" size=18></feather></button>
        </div>
      </form>
      <div class="tc" v-if="step === 3 " :style="(step === 3) ? '' : 'display: none;'">
        <tc/>
        <button style="background-color: #EF5350;" class="acceptTc" @click="step--"> Accept Terms and Conditions </button>
      </div>
      <br/><br/><br/>
      <router-link to="/login" v-if="step!=3" class="login-signup-change">Already have an account?</router-link>
    </main>
    <!--<span class="copyright">© Wrapp {{ new Date().getFullYear() }}</span>-->
  </div> 
</template>

<script>
import Loading from "@/components/Loading";
import tc from "@/views/tc"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3}?)[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
const auth = getAuth();

  extend('required', {
    ...required,
    message: 'This field is required.'
  })

  extend('email', {
    ...email,
    message: 'Invalid email'
  })

  extend('vatLength', {
    params: [],
    validate(value) {
      if(value.length == 10)
      return /^[0-9]+$/.test(value);
    },
    message: 'Vat number must be 10 digits only'
  })

  extend('numbers', {
    validate(value) {
      return /^[0-9]+$/.test(value)
    }
  })

  extend('phone', {
    params: [],
    validate(value) {
      return phoneRegex.test(value)
    },
    message: "Invalid phone number"
  })

  extend('min', {
    validate(value, { min }) {
      return value.length >= min
    },
    params: ['min'],
    message: 'Must consist of more than {min} characters'
  })

  extend('confirmedPassword', {
    params: ['target'],
    validate(value, { target }) {
      return value == target
    },
    message: 'Passwords do not match'
  })

  export default {
    name: 'DriverSignup',
    components: {
      Loading,
      tc,
      ValidationProvider,
      ValidationObserver
    },
    data() {
      return {
        step: 1,
        user: {},
        form: {
          emailAddress: '',
          mobile: '',
          password: '',
          confirmPassword: '',
          fname: '',
          lname: '',
          companyname: '',
          vat_no: ''
        },
        errors: [],
        loading: false,
        check: false,
        show: false
      }
    },
    methods: {
      signUp: async function() {
        if (await this.$refs['observer-1'].validate()) {
          this.loading = true;
          createUserWithEmailAndPassword(auth, this.form.emailAddress, this.form.password)
            .then((res) => {
              this.user = res.user;
              this.step++;
              this.loading = false;
            })
            .catch((error) => {
              // Handle Errors here.
              this.loading = false;
              console.error(error);
              alert('Email already in use. Please use a different email address');
            });
        }
        else{
          alert('Please make sure to fill in details as required');
          this.loading = false;
        }
      },
      captureAdditionalInformation: async function() {
        if (await this.$refs['observer-2'].validate()) {
          auth.signOut();
          this.loading = true;
          if(this.form.companyname.trim().toLowerCase() == 'private' || 
          this.form.companyname.trim().toLowerCase()  == 'prvt' || 
          this.form.companyname.trim().toLowerCase()  == 'privaat'){
            alert('Invalid company name. Please leave empty if not applicable');
            this.loading = false;
            return;
          }  
          let Customer = {
            id: this.user.uid,
            mobile: this.form.mobile.trim(),
            firstName: this.form.fname.trim(),
            lastName: this.form.lname.trim(),
            companyName: this.form.companyname.trim(),
            vatNo: this.form.vat_no.trim(),
            emailAddress: this.form.emailAddress.trim(),
            scope: 'pending'
          } 
          await this.$store.dispatch('auth/registerUser', Customer);
          this.step++;
          this.loading = false;
          alert('Your account has been registered. We will be in touch in order to activate your account');
          window.location.reload();
          window.location.href = '/login';    
        }
        else{
          alert('Please make sure to fill in details as required');
        }
      }
    }
  }
</script>

<style lang="scss" scoped src="@/scss/auth.scss"></style>